import { httpGet } from "@/services/api.service";
import { ENDPOINT_CUSTOM_LAYERS } from "@/common/constants/api";

export { _getCustomLayers as getCustomLayers };

const _getCustomLayers = async () => {
  try {
    const URL = ENDPOINT_CUSTOM_LAYERS;
    const RESULT = await httpGet({ url: URL, noCache: true });
    const { data } = JSON.parse(RESULT);
    return data;
  } catch (error) {
    console.error(error);
    Promise.reject("Issue getting custom layers in customLayer.service.js");
  }
};
